<template>
  <v-container>
    <v-row>
      <v-col
        ><v-row>
          <h1 class="pl-2">
            {{ $t("storyHub.publishing.wizard.creditsAndSponsors") }}
          </h1>
        </v-row>
        <CreditsAndSponsors :editable="false" />
      </v-col>
      <v-col>
        <v-row>
          <h1>{{ $t("storyHub.publishing.publishedStatus") }}</h1>
        </v-row>
        <v-row>
          <v-sheet
            width="100%"
            class="rounded-xl"
            height="20em"
            color="secondaryBackground"
          >
            <v-container fluid class="fill-height">
              <v-row align="center">
                <v-col cols="12" class="black--text">
                  <div v-if="inReview">
                    <p>
                      <v-icon color="black">mdi-dots-horizontal-circle</v-icon>
                    </p>
                    <p>{{ $t('storyHub.publishing.pendingApproval') }}</p>
                  </div>
                  <div v-else-if="published">
                    <p>{{ $t('storyHub.publishing.published') }}: <br />{{ publishedDate }}</p>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import CreditsAndSponsors from "./CreditsAndSponsors";
import iris from "@/iris";
import { STORY_STATUS } from "@/const"
export default {
  props: {
    status: String,
    statusUpdatedAt: String,
  },
  components: {
    CreditsAndSponsors,
  },
  computed: {
    published() {
      return (this.status == iris.status + STORY_STATUS.Published )
    },
    inReview() {
      return (this.status == iris.status + encodeURI(STORY_STATUS.InReview) )
    },
    publishedDate() {
      return moment(this.statusUpdatedAt).format('MMMM Do YYYY, h:mma')
    },
  },
};
</script>